
import { defineComponent, onMounted, ref, watchEffect } from 'vue';
import { MDCLinearProgress } from '@material/linear-progress';

export default defineComponent({
  name: 'MdcLinearProgress',
  props: {
    isOpen: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  setup(props) {
    const linearProgressRef = ref<HTMLDivElement>();
    const linearProgress = ref<MDCLinearProgress>();

    onMounted(() => {
      if (!linearProgressRef.value) return;

      linearProgress.value = new MDCLinearProgress(linearProgressRef.value);
      linearProgress.value.determinate = false;
    });

    watchEffect(() => {
      props.isOpen ? linearProgress.value?.open() : linearProgress.value?.close();
    });

    return {
      linearProgressRef
    };
  }
});
